import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=255d32f8&"
import script from "./Invitation.vue?vue&type=script&lang=js&"
export * from "./Invitation.vue?vue&type=script&lang=js&"
import style0 from "./Invitation.vue?vue&type=style&index=0&id=255d32f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports